import { MOBILE } from '@/src/constants/deviceTypes'
import { LUGGAGE_PROTECTION, TRIPADD } from '@/src/constants/itinerary/insurance'
import { DeviceType } from '@/src/types/deviceType'
import { VasAncillary } from '@/src/types/itinerary'
import { TranslationFunction } from '@/src/types/translations'
import { isCleartrip } from '@/src/utils/generalUtils/isCleartrip'
import { Box } from '@mui/material'
import InsuranceFooterWrapper from './insuranceFooter'
import InsuranceItemWrapper from './insuranceItem'
import TripAddLPCTItemCard from './tripAddLPCTItemCard'

const Insurance = ({
    insuranceList,
    selectedInsurances,
    termsAndConditionsUrl,
    isInsuranceTermsAndConditionsChecked,
    insuranceTermsAndConditionsError,
    handleInsuranceClick,
    onTermsChange,
    formatCurrency,
    t,
    deviceType
}: {
    insuranceList: VasAncillary[]
    selectedInsurances: VasAncillary[]
    termsAndConditionsUrl: string
    isInsuranceTermsAndConditionsChecked: boolean
    insuranceTermsAndConditionsError: boolean
    handleInsuranceClick: (insurance: VasAncillary, actionType: 'ADD' | 'REMOVE') => void
    t: TranslationFunction<'common'>
    formatCurrency: (amount: number) => string
    onTermsChange: () => void
    deviceType: DeviceType
}) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {insuranceList.map((insurance, index) => {
                if (insurance.vasProvider !== TRIPADD) return null
                const vasDetail = insurance.vasDetails?.[0]
                const {
                    text: title = '',
                    icon: imageSrc = '',
                    shortDescription = '',
                    tripPremiumDetails: { totalPremiumAmount = 0 },
                    description,
                    benefits = []
                } = vasDetail || {}

                const isSelected = selectedInsurances.some(
                    selectedInsurance => selectedInsurance.vasType === insurance.vasType
                )
                const isCleartripLuggageMobile =
                    deviceType === MOBILE && insurance.vasType === LUGGAGE_PROTECTION && isCleartrip()

                const onInsuranceClick = () => {
                    handleInsuranceClick(insurance, isSelected ? 'REMOVE' : 'ADD')
                }

                if (isCleartripLuggageMobile) {
                    return (
                        <TripAddLPCTItemCard
                            key={`${insurance.vasType}_${index}`}
                            insurance={insurance}
                            index={index}
                            isSelected={isSelected}
                            onInsuranceClick={onInsuranceClick}
                            formatCurrency={formatCurrency}
                            globalTermsAndConditionsUrl={termsAndConditionsUrl}
                        />
                    )
                }

                return (
                    <InsuranceItemWrapper
                        key={`${insurance.vasType}_${index}`}
                        id={`${insurance.vasType}_${index}`}
                        onInsuranceClick={onInsuranceClick}
                        imageSrc={imageSrc}
                        title={title}
                        description={description}
                        shortDescription={shortDescription}
                        totalPremiumAmount={formatCurrency(totalPremiumAmount)}
                        isSelected={isSelected}
                        t={t}
                        deviceType={deviceType}
                        benefits={benefits}
                    />
                )
            })}

            {/* Insurance Footer */}
            {!!insuranceList?.length && (
                <InsuranceFooterWrapper
                    insuranceTermsAndConditionsError={insuranceTermsAndConditionsError}
                    onTermsChange={onTermsChange}
                    termsAndConditionsUrl={termsAndConditionsUrl}
                    isInsuranceTermsAndConditionsChecked={isInsuranceTermsAndConditionsChecked}
                    t={t}
                />
            )}
        </Box>
    )
}

export default Insurance
